
import { Component, Vue } from 'vue-property-decorator';

import {
  getPartsList,
  setPartsSetting,
  addParts,
  editParts,
  deleteParts,
  addModel,
  editModel,
  deleteModel,
  moveModel,
  exportPartsNew
} from '@/api/parts';
import { UserModule } from '@/store/modules/user';
import { parse } from 'path';
import { IPagination } from '@/types';
import { makeKey } from '@/utils/qiniu';
import { getQiniuToken } from '../../api/third';
import { Qiniu } from '@/types/qiniu';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import dialogSetImport from '../staff/components/setImport.vue';
import PartsChildrenList from './components/PartsChildrenList.vue';
import {
  checkPermissionCompany
} from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { getUserInfo } from '@/api/users';
import { toFixed2 } from '@/utils';

// 1已同步 2未同步
const statusOptions = [
  {
    value: '2',
    label: '未同步'
  },
  {
    value: '1',
    label: '已同步'
  }
];
const sourceType = [
  {
    value: '3',
    label: '工程师'
  },
  {
    value: '1',
    label: '公司'
  }
];
@Component({
  name: 'PartsMine',
  components: {
    dialogImgLarge,
    dialogSetImport,
    PartsChildrenList
  },
  filters: {
    getSource(val: any) {
      let t = '';
      switch (parseInt(val)){
        case 1:
          t='公司';
          break;
        case 3:
          t='工程师';
          break;
        default:
          t='';
          break;
      }
      return t;
    }
  }
})
export default class extends Vue {
  // 7牛
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private qiuniuform = {};
  private qiniu: any;

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private formSearch = {
    part: '',
    name: '',
    model: '',
    status: ''
  };
  private statusOptions = statusOptions;
  private sourceType=sourceType;
  private isShowStatus=false;

  private sourceTypeDisabled=true;

  private showPartsAmount =
    parseInt((UserModule.getCompany as any).is_parts_price_show) === 1;
  private isPartsChange =
    parseInt((UserModule.getCompany as any).is_modify_price) === 1;
  private isPartsApply =
    parseInt((UserModule.getCompany as any).is_parts_apply) === 1;
  private listLoading = false;
  private tableData = [];
  private multipleSelectionData = [];
  private dialogAddPartVisible = false;
  private formAddPart = {
    id: '',
    type: 1,
    pid: '',
    parent_name: '',
    name: '',
    price: '',
    serial: '',
    specification: '',
    remark: '',
    imageUrl: '',
    is_apply:false,
    sort: 100
  };
  // 操作子级名称后刷新对应层级的回调（为空时刷新主列表）
  private pendingRefresh: (() => void) | null = null;
  private dialogAddModelVisible = false;
  private formAddModel = {
    id: '',
    type: 1,
    parts_name: '',
    parts_id: '',
    price: '',
    serial: '',
    specification: '',
    imageUrl: '',
    name: '',
    remark: '',
    imgKey: '',
    sort: 100,
    baseCostCompany: '',
    baseCostPerson: '',
    sourceType: '',
    is_apply:false,
  };
  // 已选中的型号（大类展开区内），每项携带 _pid 标识所属大类
  private selectedModels: any[] = [];
  // 移动型号弹框
  private moveModelDialogVisible = false;
  private moveModelForm: {
    target: any[]
  } = {
    target: []
  };
  // 移动型号目标级联选择器配置（大类 → 名称）
  private moveModelCascaderProps: any = {
    checkStrictly: true,
    lazy: true,
    lazyLoad: (node: any, resolve: any) => {
      const { level, value } = node;
      const params: any = {
        user_id: UserModule.getUserId,
        company_id: UserModule.getCompanyId,
        pid: level === 0 ? 0 : value,
        is_need_child_count: 1,
        page: 1,
        size: 9999
      };
      getPartsList(params)
        .then((res: any) => {
          const list = (res.data && res.data.list) || [];
          const nodes = list.map((item: any) => ({
            value: item.id,
            label: item.name,
            // 大类不允许直接作为目标，仅名称可选
            disabled: level === 0,
            leaf: parseInt(item.children_count || 0) === 0
          }));
          resolve(nodes);
        })
        .catch(() => resolve([]));
    }
  };
  created() {
    this.isShowStatus = checkPermissionCompany(UserModule.getCompanyId, Type.Stock);
    const params = {
      type: Qiniu.UPLOAD_TYPE_PARTS
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
    this.getPartsList();
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getPartsList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = size;
    this.getPartsList();
  }

  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getPartsList();
  }

  // 清空
  private handleSearchClear() {
    this.pagination.currentPage = 1
    this.formSearch = {
      part: '',
      name: '',
      model: '',
      status: ''
    };
    this.collapseAllRows();
    this.getPartsList();
  }

  // 收起所有一级展开行（row-key 模式下数据刷新后展开状态会按 id 保留，需手动收起）
  private collapseAllRows() {
    const table: any = this.$refs.partsTable;
    if (!table) {
      return;
    }
    const expandRows: any[] = (table.store.states.expandRows || []).slice();
    expandRows.forEach((row: any) => {
      table.toggleRowExpansion(row, false);
    });
  }

  // 获取备件列表
  private getPartsList() {
    this.listLoading = true;
    // 刷新主列表时，展开区型号选择失效
    this.selectedModels = [];
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_name: this.formSearch.part,
      c_parts_name: this.formSearch.name,
      modal_name: this.formSearch.model,
      is_sync: this.formSearch.status,
      is_need_child_count: 1,
      pid:0,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    getPartsList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.pagination.total = 0;
        this.tableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 展开行：懒加载下级名称（名称列表接口传 pid 获取）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.id === row.id);
    if (expanded) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    // 重新拉取当前大类下的名称时，同步清掉该大类已记录的型号选择
    this.selectedModels = this.selectedModels.filter(
      (m: any) => m._pid !== row.id
    );
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      pid: row.id,
      c_parts_name: this.formSearch.name,
      is_need_child_count: 1,
      page: 1,
      size: 9999
    };
    // 搜索型号有值时，二级列表也按型号过滤
    if (this.formSearch.model) {
      params.modal_name = this.formSearch.model;
    }
    getPartsList(params)
      .then((res: any) => {
        const data = res.data;
        const list = data && data.list ? data.list : [];
        this.$set(row, 'childrenx', list);
        this.$set(row, 'children_count', list.length);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  // 增删改后刷新：优先刷新子级名称所在层级，否则刷新主列表
  private refreshAfter() {
    const refresh = this.pendingRefresh;
    this.pendingRefresh = null;
    if (refresh) {
      refresh();
    } else {
      this.getPartsList();
    }
  }

  // 设置 不显示备件费用金额详情
  private settingChange1(val: any) {
    const params = {
      is_parts_price_show: val ? 1 : 0
    };
    this.partsSetting(params);
  }
  // 设置 备件可修改费用
  private settingChange2(val: any) {
    const params = {
      is_modify_price: val ? 1 : 0
    };
    this.partsSetting(params);
  }

    // 设置 备件可修改费用
  private settingApply(val: any) {
    const params = {
      is_parts_apply: val ? 1 : 0
    };
    this.partsSetting(params);
  }

  // 调用备件设置接口
  private partsSetting(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...val
    };
    setPartsSetting(params)
      .then(async(res: any) => {
        this.showSuccessMsg(res.msg);
        let parameters: any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId;
        await getUserInfo(parameters).then(async(res) => {
          await UserModule.setLogin(res.data);
        });
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  private closeAddParts() {
    this.dialogAddPartVisible = false;
    this.formAddPart = {
      id: '',
      type: 1,
      pid: '',
      parent_name: '',
      name: '',
      price: '',
      serial: '',
      specification: '',
      remark: '',
      imageUrl: '',
      sort: 100,
      is_apply:false,
    };
  }

  // 添加备件按钮触发
  private addPartHandle() {
    this.pendingRefresh = null;
    this.dialogAddPartVisible = true;
    this.formAddPart.type = 1;
    this.formAddPart.pid = '';
    this.formAddPart.parent_name = '';
  }

  // 添加下级名称按钮触发
  private addChildNameHandle(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.dialogAddPartVisible = true;
    this.formAddPart.type = 1;
    this.formAddPart.pid = val.id;
    this.formAddPart.parent_name = val.name;
  }
  // 添加备件保存按钮触发
  private addPartsSave() {
    if (this.formAddPart.type === 1) {
      this.addParts();
    } else {
      this.editParts();
    }
  }

  // 添加备件
  private addParts() {
    if (!this.formAddPart.name) {
      this.showErrorMsg('请输入名称');
      return;
    }
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formAddPart.name,
      is_apply: this.formAddPart.is_apply ? 1 : 0,
      sort: this.formAddPart.sort
    };
    // 添加下级名称时传 pid
    if (this.formAddPart.pid) {
      params.pid = this.formAddPart.pid;
    }
    addParts(params)
      .then((res: any) => {
        this.closeAddParts();
        this.showSuccessMsg(res.msg);
        this.refreshAfter();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 编辑备件
  private editPartsHandle(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.dialogAddPartVisible = true;
    this.formAddPart.type = 2;
    this.formAddPart.pid = '';
    this.formAddPart.parent_name = '';
    this.formAddPart.name = val.name;
    this.formAddPart.id = val.id;
    this.formAddPart.is_apply = parseInt(val.is_apply)==1 ? true : false,
    this.formAddPart.sort = val.sort;
  }

  // 编辑备件
  private editParts() {
    if (!this.formAddPart.name) {
      this.showErrorMsg('请输入名称');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: this.formAddPart.id,
      name: this.formAddPart.name,
      is_apply: this.formAddPart.is_apply ? 1 : 0,
      sort: this.formAddPart.sort
    };
    editParts(params)
      .then((res: any) => {
        this.closeAddParts();
        this.showSuccessMsg(res.msg);
        this.refreshAfter();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 删除备件
  private deletePartsHandle(val: any, refresh?: () => void) {
    if (val.children_count && parseInt(val.children_count) > 0) {
      this.$notify({
        title: '提示',
        message: '该备件存在下级，请先删除下级',
        type: 'warning'
      });
      return;
    }
    this.pendingRefresh = refresh || null;
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.deleteParts(val.id);
      })
      .catch(() => {});
  }

  private deleteParts(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: val
    };
    deleteParts(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        this.refreshAfter();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加型号按钮触发
  private addModelHandle(val: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.formAddModel.parts_name = val.name;
    this.formAddModel.parts_id = val.id;
    this.formAddModel.type = 1;
    this.formAddModel.sourceType = '1';
    this.dialogAddModelVisible = true;
  }

  // 关闭添加型号 dialog清楚数据
  private closeAddModel() {
    this.dialogAddModelVisible = false;
    this.formAddModel = {
      id: '',
      type: 1,
      parts_id: '',
      parts_name: '',
      price: '',
      serial: '',
      specification: '',
      imageUrl: '',
      name: '',
      remark: '',
      imgKey: '',
      sort: 100,
      baseCostCompany: '',
      baseCostPerson: '',
      sourceType: '1',
      is_apply:false,
    };
  }
  private proving1(type:number) {
    if (type === 1) {
      this.formAddModel.baseCostCompany = toFixed2(this.formAddModel.baseCostCompany);
    } else {
      this.formAddModel.baseCostPerson = toFixed2(this.formAddModel.baseCostPerson);
    }
  }
  // 添加/编辑型号保存触发
  private addModelSave() {
    if (this.formAddModel.type === 1) {
      this.addModel();
    } else {
      this.editModel();
    }
  }

  // 添加型号 保存数据
  private addModel() {
    if (!this.formAddModel.name) {
      this.showErrorMsg('请输入备件型号');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: this.formAddModel.parts_id,
      name: this.formAddModel.name,
      remark: this.formAddModel.remark,
      serial_number: this.formAddModel.serial,
      specification: this.formAddModel.specification,
      image_save_path: this.formAddModel.imgKey,
      unit_price: this.formAddModel.price,
      sort: this.formAddModel.sort,
      company_price: this.formAddModel.baseCostCompany,
      person_price: this.formAddModel.baseCostPerson,
      source_type: this.formAddModel.sourceType,
      is_apply: this.formAddModel.is_apply ? 1 : 0,
    };
    addModel(params)
      .then((res: any) => {
        this.closeAddModel();
        this.showSuccessMsg(res.msg);
        this.refreshAfter();
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 编辑型号
  private editModelHandle(val: any, valp: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    this.formAddModel = {
      type: 2,
      id: val.id,
      parts_name: valp.name,
      parts_id: valp.id,
      price: val.unit_price,
      serial: val.serial_number,
      specification: val.specification,
      imageUrl: val.image_save_path,
      name: val.name,
      remark: val.remark,
      imgKey: val.image_short_path,
      sort: val.sort,
      baseCostCompany: val.company_price,
      baseCostPerson: val.person_price,
      sourceType: val.source_type,
      is_apply: parseInt(val.is_apply)==1 ? true : false,
    };
    this.sourceTypeDisabled = parseInt(val.source_type) === 1
    this.dialogAddModelVisible = true;
  }

  private editModel() {
    if (!this.formAddModel.name) {
      this.showErrorMsg('请输入备件型号');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: this.formAddModel.parts_id,
      model_id: this.formAddModel.id,
      name: this.formAddModel.name,
      remark: this.formAddModel.remark,
      serial_number: this.formAddModel.serial,
      specification: this.formAddModel.specification,
      image_save_path: this.formAddModel.imgKey,
      unit_price: this.formAddModel.price,
      sort: this.formAddModel.sort,
      company_price: this.formAddModel.baseCostCompany,
      person_price: this.formAddModel.baseCostPerson,
      source_type: this.formAddModel.sourceType,
      is_apply: this.formAddModel.is_apply ? 1 :0 ,
    };
    editModel(params)
      .then((res: any) => {
        this.closeAddModel();
        this.showSuccessMsg(res.msg);
        this.refreshAfter();
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 删除备件型号
  private deleteModelHandle(val: any, valp: any, refresh?: () => void) {
    this.pendingRefresh = refresh || null;
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.deleteModel(val.id);
      })
      .catch(() => {});
  }

  private deleteModel(val:any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      model_id: val
    };
    deleteModel(params)
      .then((res: any) => {
        this.dialogAddModelVisible = false;
        this.showSuccessMsg(res.msg);
        this.refreshAfter();
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 批量处理下拉命令分发
  private handleBatchCommand(command: string) {
    if (command === 'delete') {
      this.deleteGroupHandle();
    } else if (command === 'move') {
      this.moveModelHandle();
    }
  }

  // 大类展开区内型号选择变化，以大类 id 为维度聚合到全局 selectedModels
  private handleModelSelectionChange(parentRow: any, rows: any[]) {
    const pid = parentRow && parentRow.id;
    this.selectedModels = this.selectedModels.filter((m: any) => m._pid !== pid);
    (rows || []).forEach((r: any) => {
      this.selectedModels.push({ ...r, _pid: pid });
    });
  }

  // 批量删除（仅处理已选中的大类，型号选中不参与删除）
  private deleteGroupHandle() {
    this.pendingRefresh = null;
    if (this.multipleSelectionData.length > 0) {
      let _this = this;
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var tempId = '';
          for (var i = 0; i < this.multipleSelectionData.length; i++) {
            tempId += (this.multipleSelectionData[i] as any).id + ',';
          }
          if (tempId.endsWith(',')) {
            tempId = tempId.slice(0, tempId.length - 1);
          }
          _this.deleteParts(tempId);
        })
        .catch(() => {});
    } else {
      this.$notify({
        title: '提示',
        message: '请选择需要删除的备件大类',
        type: 'warning'
      });
    }
  }

  // 移动型号
  private moveModelHandle() {
    if (this.selectedModels.length === 0) {
      this.$notify({
        title: '提示',
        message: '请先在大类展开区内选择需要移动的型号',
        type: 'warning'
      });
      return;
    }
    this.moveModelForm.target = [];
    this.moveModelDialogVisible = true;
  }

  private closeMoveModel() {
    this.moveModelDialogVisible = false;
    this.moveModelForm.target = [];
  }

  private confirmMoveModel() {
    const target = this.moveModelForm.target || [];
    if (target.length < 2) {
      this.showErrorMsg('请选择大类下的名称作为目标');
      return;
    }
    const targetPartsId = target[target.length - 1];
    const modelIds = this.selectedModels.map((m: any) => m.id);
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: targetPartsId,
      model_ids: modelIds.join(',')
    };
    moveModel(params)
      .then((res: any) => {
        this.showSuccessMsg((res && res.msg) || '移动成功');
        this.moveModelDialogVisible = false;
        this.moveModelForm.target = [];
        this.selectedModels = [];
        this.getPartsList();
      })
      .catch((err: any) => {
        this.showErrorMsg((err && err.msg) || '移动失败');
      });
  }

  private selectable(row:any, index:any) {
    let del = true;
    if (parseInt(row.is_charge_off) === 1) {
      del = false;
    }
    return del;
  }
  private handleSelectionChange(val: any) {
    this.multipleSelectionData = val;
  }

  private handleAvatarSuccess(res: any, file: any) {
    this.formAddModel.imageUrl = this.qiniu.default_url + res.key;
    this.formAddModel.imgKey = res.key;
  }
  private beforeAvatarUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  private deleteImgHandle() {
    this.formAddModel.imageUrl = '';
    this.formAddModel.imgKey = '';
  }

  // 导出Excel
  handleExport() {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName
    };
    exportPartsNew(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  // 导入
  private setImportVisible = false
  private setImportTitle='导入备件'
  private importHandle() {
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.getPartsList();
    this.setImportVisible = value;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
